import { AccessTime, Store, Style } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import Breakable from "./Breakable";
import { ReservationState } from "../util/useReservationState";
import Time from "../util/Time";
import { ColorHexCodes } from "../util/Color";
import { StyledText } from "./StyledText";

export function FloatingUIForm1() {
  return <div></div>;
}

export function FloatingUI({ state, canGoBack, isValid, onPrev, onNext }: { state: ReservationState; canGoBack: boolean; isValid: boolean; onPrev: () => void; onNext: () => void }) {
  if (!state.data.date || !state.data.store) {
    return <></>;
  }

  const nextButtonText = state.data.store.skip_confirm ? "予約確定" : "次へ";
  const ds = new Time(state.data.date).DateStrings();
  return (
    <Stack style={{ position: "fixed", bottom: 0, width: "100vw", alignItems: "center", left: 0, padding: "18px 32px", background: "white", boxShadow: "0 0 20px gray" }}>
      <Stack flex={1} width={"100%"} maxWidth={540} style={{ gap: "6px" }}>
        <Stack flexDirection={"row"} alignItems={"center"} style={{ gap: "10px", fontSize: 15 }}>
          <Store />
          <StyledText>{state.data.store.name}</StyledText>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} style={{ gap: "10px", fontSize: 15 }}>
          <Style />
          <StyledText>{state.data.course?.name}</StyledText>
        </Stack>
        <Stack direction={"row"} alignItems={"center"} style={{ gap: "10px" }}>
          <AccessTime />
          <Breakable texts={[`${ds.year}年${ds.month}月${ds.date}日(${ds.day})`, `${ds.hour}時${ds.minute}分`, ` (${(state.data.course?.duration ?? 0) / Time.AMinute}分間)`]} />
        </Stack>
        <Stack width={"100%"} direction="row" spacing={1} flex={1}>
          <Button variant="contained" color="inherit" disabled={!canGoBack} sx={{ flexGrow: 1, padding: "10px 0" }} onClick={onPrev}>
            戻る
          </Button>
          <Button variant="contained" color="primary" disabled={!isValid} sx={{ flexGrow: 1, padding: "10px 0", color: "white" }} onClick={onNext}>
            {nextButtonText}
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}

export function FloatingConfirmUI({ onPrev, onNext }: { onPrev: () => void; onNext: () => void }) {
  return (
    <Stack style={{ position: "fixed", bottom: 0, width: "100vw", alignItems: "center", left: 0, padding: "18px 32px", background: "white", boxShadow: "0 0 20px gray" }}>
      <Stack flex={1} width={"100%"} maxWidth={540} style={{ gap: "6px" }}>
        <Stack style={{ color: `#${ColorHexCodes.RequiredRed}`, alignItems: "center" }}>
          <StyledText textStyle={"Bold"}>{"!予約はまだ完了していません!"}</StyledText>
          <StyledText>{"内容に問題がなければ【予約確定】ボタンを押してください"}</StyledText>
        </Stack>
        <Stack direction={"row"} gap={1}>
          <Button variant="contained" color="inherit" sx={{ flex: 1, padding: "10px 0" }} onClick={onPrev}>
            戻る
          </Button>
          <Button variant="contained" color="primary" sx={{ flex: 1, padding: "10px 0", color: "white" }} onClick={onNext}>
            予約確定
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
}
